import React from "react";
import { IconButton, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function QuantityField({ value = 1, onChange }) {
  const handleIncrement = () => {
    onChange?.(parseInt(value || "0", 10) + 1);
  };

  const handleDecrement = () => {
    const newValue = Math.max(1, parseInt(value || "1", 10) - 1);
    onChange?.(newValue);
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
      const intVal = val === "" ? "" : Math.max(1, parseInt(val, 10));
      onChange?.(intVal);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        height: "100%",
      }}
    >
      <IconButton size="small" onClick={handleDecrement}>
        <RemoveIcon fontSize="small" />
      </IconButton>
      <TextField
        size="small"
        variant="outlined"
        value={value}
        onChange={handleInputChange}
        inputProps={{ min: 1 }}
      />
      <IconButton size="small" onClick={handleIncrement}>
        <AddIcon fontSize="small" />
      </IconButton>
    </div>
  );
}

export default QuantityField;
